module.exports = __webpack_public_path__ + "img/4w_tassei.258b0f57.png";